var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#00c8c8",
    "data-original": "#00c8c8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1baaaa",
    d: "M512 256c0-6.203-.221-12.354-.655-18.446L361.002 87.211l-19.777 30.647L300.367 77 112.166 424.789l78.904 78.904C211.805 509.114 233.566 512 256 512c141.385 0 256-114.615 256-256z",
    "data-original": "#1baaaa",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M112.166 87.211h248.836V424.79H112.166z",
    "data-original": "#ffce00",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M237.446 87.211h123.556v337.578H237.446z",
    "data-original": "#fdba12",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M140.15 118.272h192.868V393.24H140.15z",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M237.446 118.272h95.572V393.24h-95.572z",
    "data-original": "#e9edf5",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7628",
    d: "M172.8 77h127.567v64.729H172.8z",
    "data-original": "#fe6a16",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f24500",
    d: "M237.446 77h62.921v64.729h-62.921z",
    "data-original": "#f24500",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdd2e1",
    d: "M164.188 168.43H308.98v30H164.188z",
    "data-original": "#cdd2e1",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4c8",
    d: "M237.446 168.43h71.534v30h-71.534z",
    "data-original": "#afb4c8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdd2e1",
    d: "M164.188 236.521H308.98v30H164.188z",
    "data-original": "#cdd2e1",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4c8",
    d: "M237.446 236.521h71.534v30h-71.534z",
    "data-original": "#afb4c8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdd2e1",
    d: "M164.188 304.611H308.98v30H164.188z",
    "data-original": "#cdd2e1",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afb4c8",
    d: "M237.446 304.611h71.534v30h-71.534z",
    "data-original": "#afb4c8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555a66",
    d: "M333.018 215.452h35.676v31.805h-35.676z",
    "data-original": "#555a66",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333940",
    d: "M350.096 215.452h18.597v31.805h-18.597z",
    "data-original": "#333940",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.856,
    cy: 335.011,
    r: 101.215,
    fill: "#707789",
    "data-original": "#707789"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555a66",
    d: "M350.856 233.796c-.254 0-.506.008-.759.01v202.412c.253.002.505.01.759.01 55.9 0 101.216-45.316 101.216-101.216-.001-55.9-45.317-101.216-101.216-101.216z",
    "data-original": "#555a66",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.856,
    cy: 335.011,
    r: 78.181,
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M350.856 256.83c-.255 0-.505.017-.759.02v156.324c.254.002.505.019.759.019 43.178 0 78.181-35.003 78.181-78.181s-35.003-78.182-78.181-78.182z",
    "data-original": "#e9edf5",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414952",
    d: "M319.783 196.988h62.144v26.804h-62.144z",
    "data-original": "#414952",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#23272b",
    d: "M350.096 196.988h31.832v26.804h-31.832z",
    "data-original": "#23272b",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#555a66",
    d: "M365.855 322.557v-47.556h-30v47.557a19.42 19.42 0 0 0-4.496 12.454c0 10.768 8.729 19.496 19.496 19.496s19.496-8.729 19.496-19.496a19.41 19.41 0 0 0-4.496-12.455z",
    "data-original": "#555a66",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333940",
    d: "M365.855 322.557v-47.556h-15.759v79.468c.254.01.503.039.759.039 10.767 0 19.496-8.729 19.496-19.496a19.41 19.41 0 0 0-4.496-12.455z",
    "data-original": "#333940",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcon);
export default __webpack_public_path__ + "static/media/reviewIcon.925d6a284e6686920fed2b679b6f3f2d.svg";
export { ForwardRef as ReactComponent };